import React from "react";
import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faClock,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";

const TimeLocationCard = ({ curr_time, detected_loc, timezone }) => {
  const timeMoment = moment(curr_time, "YYYY-MM-DD HH:mm:ss Z");

  return (
    <Card
      className="shadow-lg"
      style={{
        display: "flex",
        flexDirection: "row",
        width: "300px",
        border: "none",
        borderRadius: "12px",
        marginBottom: "15px",
        overflow: "hidden",
        backgroundColor: "#1c1a1d",
      }}
    >
      {/* Left Section */}
      <div
        style={{
          backgroundColor: "#1c1a1d",
          color: "#d9d9d9",
          flex: "1",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <h2 style={{ margin: 0, fontSize: "2rem" }}>
          {timeMoment.format("DD")}
        </h2>
        <p style={{ margin: 0, fontSize: "1rem", textTransform: "uppercase" }}>
          {timeMoment.format("MMM")}
        </p>
      </div>

      {/* Right Section */}
      <div
        style={{
          backgroundImage:
            "linear-gradient(to right top, #1a5055, #004f66, #004c77, #26447f, #56357a)",
          color: "#d9d9d9",
          flex: "2",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-around",
        }}
      >
        {/* Time */}
        <div style={{ textAlign: "left" }}>
          <p style={{ margin: "5px 0", fontSize: "0.9rem" }}>
            <FontAwesomeIcon
              icon={faClock}
              style={{ fontSize: "1rem", color: "#a0a0a0" }}
            />{" "}
            {timeMoment.format("HH:mm a")}
          </p>
        </div>

        {/* Location */}
        <div style={{ textAlign: "left" }}>
          <p style={{ margin: "5px 0", fontSize: "0.9rem" }}>
            <FontAwesomeIcon
              icon={faMapMarkerAlt}
              style={{ fontSize: "1rem", color: "#a0a0a0" }}
            />{" "}
            {detected_loc}
          </p>
        </div>

        {/* Timezone */}
        {/* <div style={{ textAlign: "left" }}>
          <p style={{ margin: "5px 0", fontSize: "0.9rem" }}>
            <FontAwesomeIcon
              icon={faGlobe}
              style={{ fontSize: "1rem", color: "#a0a0a0" }}
            />{" "}
            {timezone}
          </p>
        </div> */}
      </div>
    </Card>
  );
};

export default TimeLocationCard;
